export default function ResourcesSection() {
  const setaLinks = [
    {
      name: 'W&RSETA',
      fullName: 'Wholesale & Retail SETA',
      website: 'www.wrseta.org.za',
      contact: '011 547 2600',
      description: 'Wholesale, retail, motor, and new tyre sectors'
    },
    {
      name: 'Services SETA',
      fullName: 'Services Sector Education & Training Authority',
      website: 'www.servicesseta.org.za',
      contact: '011 276 9600',
      description: 'Business services, community services, and financial services'
    },
    {
      name: 'TETA',
      fullName: 'Transport Education & Training Authority',
      website: 'www.teta.org.za',
      contact: '011 577 7000',
      description: 'Transport, logistics, and related services'
    },
    {
      name: 'AgriSETA',
      fullName: 'Agricultural Sector Education & Training Authority',
      website: 'www.agriseta.co.za',
      contact: '012 301 5600',
      description: 'Agriculture, forestry, and fisheries sectors'
    },
    {
      name: 'MERSETA',
      fullName: 'Manufacturing, Engineering & Related Services SETA',
      website: 'www.merseta.org.za',
      contact: '011 881 3340',
      description: 'Manufacturing, engineering, and related services'
    },
    {
      name: 'BANKSETA',
      fullName: 'Banking Sector Education & Training Authority',
      website: 'www.bankseta.org.za',
      contact: '011 805 9661',
      description: 'Banking and microfinance sectors'
    }
  ];

  const governmentLinks = [
    {
      name: 'Department of Higher Education and Training',
      website: 'www.dhet.gov.za',
      description: 'National skills development policy and oversight'
    },
    {
      name: 'Quality Council for Trades and Occupations (QCTO)',
      website: 'www.qcto.org.za',
      description: 'Occupational qualifications and quality assurance'
    },
    {
      name: 'South African Revenue Service (SARS)',
      website: 'www.sars.gov.za',
      description: 'Skills Development Levy collection and administration'
    }
  ];

  return (
    <section className="section-wrap bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Additional Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Essential links and contact information for SETA compliance and skills development
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* SETA Links */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Major SETA Contacts</h3>
            <div className="space-y-6">
              {setaLinks.map((seta, index) => (
                <div key={index} className="card p-6">
                  <div className="flex items-start justify-between mb-3">
                    <h4 className="text-lg font-semibold text-gray-900">{seta.name}</h4>
                    <div className="w-8 h-8 bg-[#2D7F3E] text-white rounded-lg flex items-center justify-center">
                      <i className="ri-external-link-line text-sm"></i>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 mb-2">{seta.fullName}</p>
                  <p className="text-sm text-gray-500 mb-3">{seta.description}</p>
                  <div className="space-y-2">
                    <div className="flex items-center">
                      <i className="ri-global-line text-[#2D7F3E] mr-2"></i>
                      <span className="text-sm text-gray-600">{seta.website}</span>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-phone-line text-[#2D7F3E] mr-2"></i>
                      <span className="text-sm text-gray-600">{seta.contact}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Government Links */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Government Resources</h3>
            <div className="space-y-6">
              {governmentLinks.map((link, index) => (
                <div key={index} className="card p-6">
                  <div className="flex items-start justify-between mb-3">
                    <h4 className="text-lg font-semibold text-gray-900">{link.name}</h4>
                    <div className="w-8 h-8 bg-green-800 text-white rounded-lg flex items-center justify-center">
                      <i className="ri-government-line text-sm"></i>
                    </div>
                  </div>
                  <p className="text-sm text-gray-500 mb-3">{link.description}</p>
                  <div className="flex items-center">
                    <i className="ri-global-line text-green-800 mr-2"></i>
                    <span className="text-sm text-gray-600">{link.website}</span>
                  </div>
                </div>
              ))}

              {/* Quick Reference Card */}
              <div className="bg-[#2D7F3E] text-white p-6 rounded-xl">
                <h4 className="text-lg font-semibold mb-4">Quick Reference</h4>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-green-100">SDL Rate:</span>
                    <span className="font-semibold">1% of annual payroll</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-100">Threshold:</span>
                    <span className="font-semibold">R500,000 annual payroll</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-100">WSP Deadline:</span>
                    <span className="font-semibold">April 30</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-100">ATR Deadline:</span>
                    <span className="font-semibold">April 30</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-green-100">Max Recovery:</span>
                    <span className="font-semibold">69.5% of SDL</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-white p-8 rounded-xl shadow-lg text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Need Help Finding Your SETA?</h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Not sure which SETA your company falls under? We can help you identify the correct SETA and guide you through the registration process.
          </p>
          <button className="btn btn-primary">
            Get SETA Identification Help
          </button>
        </div>
      </div>
    </section>
  );
}